import {inject} from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { navigationUrlForNewApplication } from '../service/navigation-urls';
import { getUser } from '@portal-workspace/grow-ui-library';
import { PISMO_ACCOUNTS_ACCESS_LEVEL } from '@portal-workspace/grow-shared-library';

export const pismoStatementDetailsAccessGuard  = (): CanActivateFn => {
  return (
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot
  ) => {
    const router = inject(Router);
    const user = getUser()
    if (user?.priviledges.some(priviledge => PISMO_ACCOUNTS_ACCESS_LEVEL.includes(priviledge))) {
        return true;
    }
    return router.navigate(navigationUrlForNewApplication())
  }
}
